import React from 'react';
import clsx from 'clsx';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import { makeStyles } from '@mui/styles';
import SnackbarContent from '@mui/material/SnackbarContent';
import { HashLink } from 'react-router-hash-link';

const Button = styled.button`
  background-color: inherit;
  color: ${(props) => (props.variant === 'warning' ? '#3b3b3b' : '#fff')};
  border: ${(props) =>
    props.variant === 'warning' ? '1px solid #3b3b3b' : '1px solid #fff'};
  border-radius: 4px;
  margin: 0 2px;
`;

const getMessage = (message) => {
  if (!Array.isArray(message)) return message;
  return (
    <>
      {message &&
        message.map((item) => {
          const { type } = item;
          return (
            <>
              {
                {
                  text: (
                    <span>
                      {item.text}
                      &nbsp;
                    </span>
                  ),
                  link_text: (
                    <span>
                      <HashLink to={item.to}>
                        <Button
                          key="subscribe"
                          aria-label="subscribe"
                          color="inherit"
                        >
                          {item.text}
                        </Button>
                      </HashLink>
                    </span>
                  ),
                }[type]
              }
            </>
          );
        })}
    </>
  );
};

const userMessage = (classes, message) => (
  <span id="client-snackbar" className={classes.message}>
    {getMessage(message)}
  </span>
);

const messageType = makeStyles(() => ({
  success: {
    backgroundColor: '#219653',
  },
  error: {
    backgroundColor: '#EB5757',
  },
  info: {
    backgroundColor: '#2E353E',
  },
  warning: {
    backgroundColor: '#F2C94C',
    color: 'black',
  },
  notify: {
    backgroundColor: '#2196f3',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

function MySnackbarContentWrapper(props) {
  const classes = messageType();
  const { message, onClose, variant, showUndo, handleUndo } = props;

  const closeButton = (
    <Button
      key="close"
      aria-label="close"
      color="inherit"
      variant={variant}
      onClick={onClose}
    >
      Dismiss
    </Button>
  );
  const undoButton = (
    <Button
      key="undo"
      aria-label="undo"
      color="inherit"
      variant={variant}
      onClick={handleUndo}
    >
      Undo
    </Button>
  );

  const action = showUndo ? [closeButton, undoButton] : [closeButton];

  return (
    <SnackbarContent
      className={clsx(classes[variant])}
      aria-describedby="client-snackbar"
      message={userMessage(classes, message)}
      data-testid={`snackbar-${variant}`}
      action={action}
    />
  );
}

MySnackbarContentWrapper.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'notify'])
    .isRequired,
};

MySnackbarContentWrapper.defaultProps = {
  message: '',
};

const SnackBarAlerts = (props) => {
  const {
    snackBarMessage,
    snackBarType,
    handleClose,
    showSnackBar,
    anchorOrigin,
    duration,
    showUndo,
    handleUndo,
  } = props;

  const autoHideDuration =
    duration || (snackBarType === 'success' ? 5000 : 10000);
  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={showSnackBar}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
    >
      <div>
        <MySnackbarContentWrapper
          onClose={handleClose}
          variant={snackBarType}
          message={snackBarMessage}
          showUndo={showUndo}
          handleUndo={handleUndo}
        />
      </div>
    </Snackbar>
  );
};

SnackBarAlerts.propTypes = {
  showSnackBar: PropTypes.bool.isRequired,
  snackBarMessage: PropTypes.string,
  snackBarType: PropTypes.string.isRequired,
  anchorOrigin: PropTypes.objectOf(PropTypes.string),
  handleClose: PropTypes.func.isRequired,
};

SnackBarAlerts.defaultProps = {
  snackBarMessage: '',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
};

export default React.memo(SnackBarAlerts);
